//src/assets/scripts/top/page.js
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

import Swiper from 'swiper';
import 'swiper/css';
import "swiper/css/scrollbar";
import { Autoplay, Scrollbar, Mousewheel, Navigation, Thumbs } from "swiper/modules";

export default class PageJS {
    constructor(common) {
        this.common = common;
        this.BREAK_SP = 767;
    }

    mq(type = "sp") {
        if (type === "sp") return `(max-width: ${this.BREAK_SP}px)`;
        if (type === "pc") return `(min-width: ${this.BREAK_SP + 1}px)`;
        return type;
    }

    init() {
        this._secTypeSwiper();
        this._tabJS();
        this._spFixInnav();

        this.common.init();//common.jsはここでinitさせる
    }

    getAssetPath(relative) {
        const hostname = window.location.hostname;
        const isLocal =
            hostname === 'localhost' ||
            hostname === '127.0.0.1' ||
            hostname.endsWith('.local');
        if (isLocal) {
            return `/dist/assets/images/${relative}`;
        } else {
            return `/wp/wp-content/themes/theme-villamom/dist/assets/images/${relative}`;
        }
    }

    _secTypeSwiper() {
        const sliderNames = [
            "type_a",
            "type_b",
            "type_c",
            "type_d",
        ];

        const createMenuSwiper = (name) => {
            const el = document.querySelector(`.${name}_swiper`);
            const el2 = document.querySelector(`.${name}_thumbnail`);
            if (!el || !el2) return;

            const sliderThumbnail = new Swiper(el2, {
                slidesPerView: "auto",
                observer: true,
                observeParents: true,
            });

            new Swiper(el, {
                modules: [Thumbs],
                slidesPerView: "auto",
                spaceBetween: 0,
                speed: 600,
                observer: true,
                observeParents: true,
                thumbs: {
                    swiper: sliderThumbnail,
                },
            });
        };

        sliderNames.forEach(createMenuSwiper);
    }

    _tabJS_BK() {
        const areas = Array.from(document.querySelectorAll(".Js_tab_area"));
        if (!areas.length) return;

        const isPc = () => window.matchMedia(this.mq("pc")).matches;
        const underNav = document.querySelector("#Under_nav_area");

        const syncUnderNavCurrent = (hash) => {
            if (!underNav) return;

            const activeLink = underNav.querySelector(`a[data-tab-link][href="${hash}"]`);
            if (!activeLink) return;

            const activeLi = activeLink.closest("li");
            const parentLi = activeLi?.parentElement?.closest("li.has_child");

            if (parentLi && !parentLi.classList.contains("current")) return;

            const scope = parentLi || underNav;
            scope.querySelectorAll("ul li").forEach((li) => {
                li.classList.remove("current");
            });

            activeLi?.classList.add("current");
        };

        const activateAt = (area, index) => {
            const btns = Array.from(area.querySelectorAll(".Js_tab_btn li"));
            const boxes = Array.from(area.querySelectorAll(".Js_tab_box .box"));

            if (!btns.length || !boxes.length) return;
            if (index < 0 || index >= btns.length || index >= boxes.length) return;

            btns.forEach((el) => el.classList.remove("current"));
            boxes.forEach((el) => el.classList.remove("current"));

            btns[index].classList.add("current");
            boxes[index].classList.add("current");

            const box = boxes[index];
            if (box?.id) {
                syncUnderNavCurrent(`#${box.id}`);
            }
        };

        const activateByHash = (hash) => {
            if (!hash) return false;

            let matched = false;

            areas.forEach((area) => {
                const boxes = Array.from(area.querySelectorAll(".Js_tab_box .box"));
                const index = boxes.findIndex((box) => `#${box.id}` === hash);
                if (index === -1) return;

                activateAt(area, index);
                matched = true;
            });

            if (matched) {
                syncUnderNavCurrent(hash);
            }

            return matched;
        };

        document.addEventListener("click", (e) => {
            const link = e.target.closest('a[data-tab-link][href^="#"]');
            if (!link || !isPc()) return;

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const href = link.getAttribute("href");
            const matched = activateByHash(href);

            if (matched) {
                history.replaceState(null, "", href);
            }
        }, true);

        if (isPc() && window.location.hash) {
            activateByHash(window.location.hash);
        }

        window.addEventListener("hashchange", () => {
            if (!isPc()) return;
            activateByHash(window.location.hash);
        });
    }

    _tabJS_BK() {
        const areas = Array.from(document.querySelectorAll(".Js_tab_area"));
        if (!areas.length) return;

        const isPc = () => window.matchMedia(this.mq("pc")).matches;
        const underNav = document.querySelector("#Under_nav_area");

        const syncUnderNavCurrent = (hash) => {
            if (!underNav) return;

            const activeLink = underNav.querySelector(`a[data-tab-link][href="${hash}"]`);
            if (!activeLink) return;

            const activeLi = activeLink.closest("li");
            const parentLi = activeLi?.parentElement?.closest("li.has_child");

            if (parentLi && !parentLi.classList.contains("current")) return;

            const scope = parentLi || underNav;
            scope.querySelectorAll("ul li").forEach((li) => {
                li.classList.remove("current");
            });

            activeLi?.classList.add("current");
        };

        const activateAt = (area, index) => {
            const btns = Array.from(area.querySelectorAll(".Js_tab_btn li"));
            const boxes = Array.from(area.querySelectorAll(".Js_tab_box .box"));

            if (!btns.length || !boxes.length) return;
            if (index < 0 || index >= btns.length || index >= boxes.length) return;

            btns.forEach((el) => el.classList.remove("current"));
            boxes.forEach((el) => el.classList.remove("current"));

            btns[index].classList.add("current");
            boxes[index].classList.add("current");

            const box = boxes[index];
            if (box?.id) {
                syncUnderNavCurrent(`#${box.id}`);
            }
        };

        const activateByHash = (hash) => {
            if (!hash) return false;

            let matched = false;

            areas.forEach((area) => {
                const boxes = Array.from(area.querySelectorAll(".Js_tab_box .box"));
                const index = boxes.findIndex((box) => `#${box.id}` === hash);
                if (index === -1) return;

                activateAt(area, index);
                matched = true;
            });

            if (matched) {
                syncUnderNavCurrent(hash);
            }

            return matched;
        };

        document.addEventListener("click", (e) => {
            const link = e.target.closest('a[data-tab-link][href^="#"]');
            if (!link || !isPc()) return;

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const href = link.getAttribute("href");
            const matched = activateByHash(href);

            if (matched) {
                history.replaceState(null, "", href);
            }
        }, true);

        if (isPc() && window.location.hash) {
            activateByHash(window.location.hash);
        }

        window.addEventListener("hashchange", () => {
            if (!isPc()) return;
            activateByHash(window.location.hash);
        });
    }


    _tabJS_BK2() {
        const areas = Array.from(document.querySelectorAll(".Js_tab_area"));
        if (!areas.length) return;

        const isPc = () => window.matchMedia(this.mq("pc")).matches;
        const underNav = document.querySelector("#Under_nav_area");

        const syncUnderNavCurrent = (hash) => {
            if (!underNav) return;

            const activeLink = underNav.querySelector(`a[data-tab-link][href="${hash}"]`);
            if (!activeLink) return;

            const activeLi = activeLink.closest("li");
            const parentLi = activeLi?.parentElement?.closest("li.has_child");

            if (parentLi && !parentLi.classList.contains("current")) return;

            const scope = parentLi || underNav;
            scope.querySelectorAll("ul li").forEach((li) => {
                li.classList.remove("current");
            });

            activeLi?.classList.add("current");
        };

        const activateAt = (area, index) => {
            const btns = Array.from(area.querySelectorAll(".Js_tab_btn li"));
            const boxes = Array.from(area.querySelectorAll(".Js_tab_box .box"));

            if (!btns.length || !boxes.length) return false;
            if (index < 0 || index >= btns.length || index >= boxes.length) return false;

            btns.forEach((el) => el.classList.remove("current"));
            boxes.forEach((el) => el.classList.remove("current"));

            btns[index].classList.add("current");
            boxes[index].classList.add("current");

            const box = boxes[index];
            if (box?.id) {
                syncUnderNavCurrent(`#${box.id}`);
            }

            return true;
        };

        const activateByHash = (hash) => {
            if (!hash) return false;

            let matched = false;

            areas.forEach((area) => {
                const boxes = Array.from(area.querySelectorAll(".Js_tab_box .box"));
                const index = boxes.findIndex((box) => `#${box.id}` === hash);
                if (index === -1) return;

                activateAt(area, index);
                matched = true;
            });

            if (matched) {
                syncUnderNavCurrent(hash);
            }

            return matched;
        };

        const activateByOutHash = (hash) => {
            if (!hash || !isPc()) return false;

            const target = document.querySelector(hash);
            if (!target || !target.hasAttribute("data-out-tab-link")) return false;

            let area = null;

            const areaSelector = target.getAttribute("data-tab-area");
            if (areaSelector) {
                area = document.querySelector(areaSelector);
            }

            if (!area) {
                area = target.closest(".Js_tab_area");
            }

            if (!area) {
                area = areas[0];
            }

            if (!area) return false;

            let index = -1;

            const explicitIndex = target.getAttribute("data-tab-index");
            if (explicitIndex !== null && explicitIndex !== "") {
                index = Number(explicitIndex);
            } else {
                const markers = Array.from(document.querySelectorAll('[data-out-tab-link]')).filter((el) => {
                    const selector = el.getAttribute("data-tab-area");
                    if (selector) {
                        return document.querySelector(selector) === area;
                    }
                    return true;
                });
                index = markers.indexOf(target);
            }

            if (Number.isNaN(index) || index < 0) return false;

            return activateAt(area, index);
        };

        document.addEventListener("click", (e) => {
            const link = e.target.closest('a[data-tab-link][href^="#"]');
            if (!link || !isPc()) return;

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const href = link.getAttribute("href");
            const matched = activateByHash(href);

            if (matched) {
                history.replaceState(null, "", href);
            }
        }, true);

        const applyInitialHash = () => {
            if (!isPc() || !window.location.hash) return;

            if (activateByHash(window.location.hash)) return;
            activateByOutHash(window.location.hash);
        };

        applyInitialHash();

        window.addEventListener("hashchange", () => {
            if (!isPc()) return;

            if (activateByHash(window.location.hash)) return;
            activateByOutHash(window.location.hash);
        });
    }

    _tabJS_BK3() {
        const areas = Array.from(document.querySelectorAll(".Js_tab_area"));
        if (!areas.length) return;

        const isPc = () => window.matchMedia(this.mq("pc")).matches;
        const underNav = document.querySelector("#Under_nav_area");

        const syncUnderNavCurrent = (hash) => {
            if (!underNav || !hash) return;

            const activeLink =
                underNav.querySelector(`a[data-tab-link][href="${hash}"]`) ||
                underNav.querySelector(`a[data-tab-link][data-out-tab-link="${hash}"]`);

            if (!activeLink) return;

            const activeLi = activeLink.closest("li");
            const parentLi = activeLi?.parentElement?.closest("li.has_child");

            if (!parentLi || !activeLi) return;

            // 同階層の子 current を外す
            parentLi.querySelectorAll("ul > li").forEach((li) => {
                li.classList.remove("current");
            });

            // 親階層の has_child から開閉系を一旦外す
            underNav.querySelectorAll("li.has_child").forEach((li) => {
                li.classList.remove("sub_open");
            });

            // 対象に current
            activeLi.classList.add("current");

            // 親を開く
            parentLi.classList.add("sub_open");
        };

        const activateAt = (area, index) => {
            const btns = Array.from(area.querySelectorAll(".Js_tab_btn li"));
            const boxes = Array.from(area.querySelectorAll(".Js_tab_box .box"));

            if (!btns.length || !boxes.length) return false;
            if (index < 0 || index >= btns.length || index >= boxes.length) return false;

            btns.forEach((el) => el.classList.remove("current"));
            boxes.forEach((el) => el.classList.remove("current"));

            btns[index].classList.add("current");
            boxes[index].classList.add("current");

            const box = boxes[index];
            if (box?.id) {
                syncUnderNavCurrent(`#${box.id}`);
            }

            return true;
        };

        const activateByHash = (hash) => {
            if (!hash) return false;

            let matched = false;

            areas.forEach((area) => {
                const boxes = Array.from(area.querySelectorAll(".Js_tab_box .box"));
                const index = boxes.findIndex((box) => `#${box.id}` === hash);
                if (index === -1) return;

                activateAt(area, index);
                matched = true;
            });

            if (matched) {
                syncUnderNavCurrent(hash);
            }

            return matched;
        };

        const activateByOutHash = (hash) => {
            if (!hash || !isPc()) return false;

            const target = document.querySelector(hash);
            if (!target || !target.hasAttribute("data-out-tab-link")) return false;

            let area = null;

            const areaSelector = target.getAttribute("data-tab-area");
            if (areaSelector) {
                area = document.querySelector(areaSelector);
            }

            if (!area) {
                area = target.closest(".Js_tab_area");
            }

            if (!area) {
                area = areas[0];
            }

            if (!area) return false;

            let index = -1;

            const explicitIndex = target.getAttribute("data-tab-index");
            if (explicitIndex !== null && explicitIndex !== "") {
                index = Number(explicitIndex);
            } else {
                const markers = Array.from(document.querySelectorAll('[data-out-tab-link]')).filter((el) => {
                    const selector = el.getAttribute("data-tab-area");
                    if (selector) {
                        return document.querySelector(selector) === area;
                    }
                    return true;
                });
                index = markers.indexOf(target);
            }

            if (Number.isNaN(index) || index < 0) return false;

            return activateAt(area, index);
        };

        document.addEventListener("click", (e) => {
            const link = e.target.closest('a[data-tab-link][href^="#"]');
            if (!link || !isPc()) return;

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const href = link.getAttribute("href");
            const matched = activateByHash(href);

            if (matched) {
                history.replaceState(null, "", href);
            }
        }, true);

        const applyInitialHash = () => {
            if (!isPc() || !window.location.hash) return;

            if (activateByHash(window.location.hash)) return;
            activateByOutHash(window.location.hash);
        };

        applyInitialHash();

        window.addEventListener("hashchange", () => {
            if (!isPc()) return;

            if (activateByHash(window.location.hash)) return;
            activateByOutHash(window.location.hash);
        });
    }


    _tabJS() {
        const areas = Array.from(document.querySelectorAll(".Js_tab_area"));
        if (!areas.length) return;

        const isPc = () => window.matchMedia(this.mq("pc")).matches;
        const underNav = document.querySelector("#Under_nav_area");

        const syncUnderNavCurrent = (hash) => {
            if (!underNav || !hash) return;

            const activeLink =
                underNav.querySelector(`a[data-tab-link][href="${hash}"]`) ||
                underNav.querySelector(`a[data-tab-link][data-out-tab-link="${hash}"]`);

            if (!activeLink) return;

            const activeLi = activeLink.closest("li");
            const parentLi = activeLi?.parentElement?.closest("li.has_child");

            if (!parentLi || !activeLi) return;

            underNav.querySelectorAll("li.has_child").forEach((li) => {
                li.classList.remove("current", "sub_open");
            });

            parentLi.querySelectorAll("ul > li").forEach((li) => {
                li.classList.remove("current");
            });

            activeLi.classList.add("current");
            parentLi.classList.add("current", "sub_open");
        };

        const syncUnderNavCurrentFromActiveTab = () => {
            const currentBox = document.querySelector(".Js_tab_area .Js_tab_box .box.current");
            if (!currentBox?.id) return;

            syncUnderNavCurrent(`#${currentBox.id}`);
        };

        const activateAt = (area, index) => {
            const btns = Array.from(area.querySelectorAll(".Js_tab_btn li"));
            const boxes = Array.from(area.querySelectorAll(".Js_tab_box .box"));

            if (!btns.length || !boxes.length) return false;
            if (index < 0 || index >= btns.length || index >= boxes.length) return false;

            btns.forEach((el) => el.classList.remove("current"));
            boxes.forEach((el) => el.classList.remove("current"));

            btns[index].classList.add("current");
            boxes[index].classList.add("current");

            const box = boxes[index];
            if (box?.id) {
                syncUnderNavCurrent(`#${box.id}`);
            }

            return true;
        };

        const activateByHash = (hash) => {
            if (!hash) return false;

            let matched = false;

            areas.forEach((area) => {
                const boxes = Array.from(area.querySelectorAll(".Js_tab_box .box"));
                const index = boxes.findIndex((box) => `#${box.id}` === hash);
                if (index === -1) return;

                activateAt(area, index);
                matched = true;
            });

            if (matched) {
                syncUnderNavCurrent(hash);
            }

            return matched;
        };

        const activateByOutHash = (hash) => {
            if (!hash || !isPc()) return false;

            const target = document.querySelector(hash);
            if (!target || !target.hasAttribute("data-out-tab-link")) return false;

            let area = null;

            const areaSelector = target.getAttribute("data-tab-area");
            if (areaSelector) {
                area = document.querySelector(areaSelector);
            }

            if (!area) {
                area = target.closest(".Js_tab_area");
            }

            if (!area) {
                area = areas[0];
            }

            if (!area) return false;

            let index = -1;

            const explicitIndex = target.getAttribute("data-tab-index");
            if (explicitIndex !== null && explicitIndex !== "") {
                index = Number(explicitIndex);
            } else {
                const markers = Array.from(document.querySelectorAll('[data-out-tab-link]')).filter((el) => {
                    const selector = el.getAttribute("data-tab-area");
                    if (selector) {
                        return document.querySelector(selector) === area;
                    }
                    return true;
                });
                index = markers.indexOf(target);
            }

            if (Number.isNaN(index) || index < 0) return false;

            return activateAt(area, index);
        };

        document.addEventListener("click", (e) => {
            const link = e.target.closest('a[data-tab-link][href^="#"]');
            if (!link || !isPc()) return;

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const href = link.getAttribute("href");
            const matched = activateByHash(href);

            if (matched) {
                history.replaceState(null, "", href);
            }
        }, true);

        const applyInitialHash = () => {
            if (!isPc() || !window.location.hash) return;

            if (activateByHash(window.location.hash)) return;
            activateByOutHash(window.location.hash);

            requestAnimationFrame(() => {
                syncUnderNavCurrentFromActiveTab();
            });
        };

        applyInitialHash();

        window.addEventListener("hashchange", () => {
            if (!isPc()) return;

            if (activateByHash(window.location.hash)) return;
            activateByOutHash(window.location.hash);

            requestAnimationFrame(() => {
                syncUnderNavCurrentFromActiveTab();
            });
        });

        if (underNav) {
            underNav.addEventListener("click", () => {
                if (!isPc()) return;

                setTimeout(() => {
                    syncUnderNavCurrentFromActiveTab();
                }, 0);
            });
        }
    }

    

   

    _spFixInnav() {
        const areas = Array.from(document.querySelectorAll("#Type_area .Js_tab_area"));
        if (!areas.length) return;

        if (this._spFixInnavMM) this._spFixInnavMM.revert();
        this._spFixInnavMM = gsap.matchMedia();

        this._spFixInnavMM.add(this.mq("sp"), () => {
            const triggers = [];

            areas.forEach((area) => {
                const btns = Array.from(area.querySelectorAll(".Js_tab_btn li"));
                const boxes = Array.from(area.querySelectorAll(".Js_tab_box .box"));

                if (!btns.length || !boxes.length) return;

                const setCurrent = (index) => {
                    btns.forEach((btn) => btn.classList.remove("current"));
                    boxes.forEach((box) => box.classList.remove("current"));

                    if (btns[index]) btns[index].classList.add("current");
                    if (boxes[index]) boxes[index].classList.add("current");
                };

                boxes.forEach((box, index) => {
                    triggers.push(
                        ScrollTrigger.create({
                            trigger: box,
                            start: "top center",
                            end: "bottom center",
                            onToggle: (self) => {
                                if (!self.isActive) return;
                                setCurrent(index);
                            },
                            // markers: true,
                        })
                    );
                });
            });

            return () => {
                triggers.forEach((st) => st.kill());
            };
        });
    }
}